import Layout from '@/framework/layout';
export default [
    {
        code: 'iov:valueAdded',
        path: '/valueAdded',
        name: 'ValueAdded',
        alwaysShow: true,
        component: Layout,
        redirect: 'DvrMonitor',
        meta: { title: '增值服务', elSvgIcon: 'Fold' },
        children: [
            {
                code: 'iov:financial',
                path: '/financial',
                name: 'financial',
                meta: { title: '金融锁车', cachePage: true },

                children: [
                    {
                        code: 'iov:financialTruck',//
                        path: '/financialTruck',
                        name: 'FinancialTruck',
                        component: () => import('@/framework/serviceView/increment/financial/financialTruckPage.vue'),
                        meta: { title: '车辆管理', cachePage: true }
                    },
                    {
                        code: 'iov:financialBusinessMonitor',//
                        path: '/financialBusinessMonitor',
                        name: 'FinancialBusinessMonitor',
                        component: () => import('@/framework/serviceView/increment/financial/businessMonitorPage.vue'),
                        meta: { title: '业务监控', cachePage: true }
                    },
                    {
                        code: 'iov:financialSms',//
                        path: '/financialSms',
                        name: 'FinancialSms',
                        component: () => import('@/framework/serviceView/increment/financial/financialSmsPage.vue'),
                        meta: { title: '短信指令', cachePage: true }
                    },
                    {
                        code: 'iov:financial3rd',//
                        path: '/financial3rd',
                        name: 'Financial3rd',
                        component: () => import('@/framework/serviceView/increment/financial/financial3rdPage.vue'),
                        // component: () => import('@/framework/serviceView/increment/financial/thirdParty/financial3rdTruckListPage.vue'),
                        meta: { title: '第三方管理', cachePage: true },
                    },
                    {
                        code: 'iov:financial3rdTruckList',//
                        path: '/financial3rdTruckList',
                        name: 'Financial3rdTruckList',
                        component: () => import('@/framework/serviceView/increment/financial/thirdParty/financial3rdTruckListPage.vue'),
                        hidden: true,
                        meta: { title: '金融公司车辆管理', cachePage: true }
                    },
                    {
                        code: 'iov:financialOrder',//
                        path: '/financialOrder',
                        name: 'FinancialOrder',
                        component: () => import('@/framework/serviceView/increment/financial/financialOrderPage.vue'),
                        meta: { title: '订单报表', cachePage: true }
                    },
                    {
                        code: 'iov:financialCollection',//
                        path: '/financialCollection',
                        name: 'FinancialCollection',
                        component: () => import('@/framework/serviceView/increment/financial/financialCollectionPage.vue'),
                        meta: { title: '确认收款', cachePage: true }
                    }
                ]
               
            },
            {
                code: 'iov:remoteControl',
                path: '/remoteControl',
                name: 'RemoteControl',
                meta: { title: '车辆远控', cachePage: true },

                children: [
                    {
                        code: 'iov:remoteControlRecord',//
                        path: '/remoteControlRecord',
                        name: 'RemoteControlRecord',
                        component: () => import('@/framework/serviceView/increment/remoteControl/controlRecordPage.vue'),
                        meta: { title: '操作记录', cachePage: true }
                    },
                    {
                        code: 'iov:remoteControlCount',//
                        path: '/remoteControlCount',
                        name: 'RemoteControlCount',
                        component: () => import('@/framework/serviceView/increment/remoteControl/controlCountPage.vue'),
                        meta: { title: '操作统计', cachePage: true }
                    },
                   
                ]
               
            },
            {
                code: 'iov:drivingBehavior',
                path: '/drivingBehavior',
                name: 'DrivingBehavior',
                meta: { title: '驾驶行为', cachePage: true },

                children: [
                    {
                        code: 'iov:dbrExecutionRate',//
                        path: '/dbrExecutionRate',
                        name: 'DbrExecutionRate',
                        component: () => import('@/framework/serviceView/increment/drivingBehavior/executionRatePage.vue'),
                        meta: { title: '提醒执行率', cachePage: true }
                    },
                    {
                        code: 'iov:drivingBehaviorAnalysis',//
                        path: '/drivingBehaviorAnalysis',
                        name: 'DrivingBehaviorAnalysis',
                        component: () => import('@/framework/serviceView/increment/drivingBehavior/drivingBehaviorAnalysisPage.vue'),
                        meta: { title: '驾驶行为分析', cachePage: true }
                    },
                    {
                        code: 'iov:dbParameterSettings',//
                        path: '/dbParameterSettings',
                        name: 'DbParameterSettings',
                        component: () => import('@/framework/serviceView/increment/drivingBehavior/parameterSettingsPage.vue'),
                        meta: { title: '参数设置', cachePage: true }
                    },
                   
                ]
               
            },

            {
                code: 'iov:dvr',
                path: '/dvr',
                name: 'dvr',
                meta: { title: '行车记录仪', cachePage: true },

                children: [
                    {
                        code: 'iov:dvrMonitor',//
                        path: '/dvrMonitor',
                        name: 'DvrMonitor',
                        component: () => import('@/framework/serviceView/dvr/monitor/dvrMonitorPage.vue'),
                        meta: { title: '车辆监控', cachePage: true }
                    },
                    {
                        code: 'iov:dvrOrder',
                        path: '/dvrOrder',
                        name: 'DvrOrder',
                        component: () => import('@/framework/serviceView/dvr/order/dvrOrderPage.vue'),
                        meta: { title: '订单管理', cachePage: true }
                    },
                    {
                        code: 'iov:dvrData',
                        path: '/dvrData',
                        name: 'DvrData',
                        component: () => import('@/framework/serviceView/dvr/data/dvrDataPage.vue'),
                        meta: { title: '数据查询', cachePage: true }
                    },
                    {
                        code: 'iov:dvrSetting',
                        path: '/dvrSetting',
                        name: 'DvrSetting',
                        component: () => import('@/framework/serviceView/dvr/setting/dvrSettingPage.vue'),
                        meta: { title: '开关配置', cachePage: true }
                    },
                    {
                        code: 'iov:dvrOplog',
                        path: '/dvrOplog',
                        name: 'DvrOplog',
                        component: () => import('@/framework/serviceView/dvr/oplog/dvrOperationLogPage.vue'),
                        meta: { title: '操作日志', cachePage: true }
                    },
                ]
               
            },
        ]
    },
];
